import { CloseButton } from './lib/close-button.js';
customElements.define('cipublic-close-button', CloseButton);
//# sourceMappingURL=cipublic-close-button.js.map